import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { VideoListModel } from '../../models/VideoListModel';
import { VideoModel } from '../../models/VideoModel';
import { MatTableDataSource } from '@angular/material/table';
import { RestAPIService } from 'src/app/services/restapi.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toaster.service';
import { PermissionService } from 'src/app/services/permission.service';
import { VideoAddEditComponent } from '../add-edit/video-add-edit.component';
import { environment } from 'src/environments/environment';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConfirmDialogComponent } from 'src/app/components/confirmation/confirm-dialog.component';
import * as moment from 'moment';
import { PaginatedResult } from 'src/app/commonmodels/PaginatedResult';
import { VideoCategoryEnum } from 'src/app/enums/videoCategoryEnum';
import { VideoTypeEnum } from 'src/app/enums/videoTypeEnum';
import { StationListModel } from 'src/app/modules/station/models/stationListModel';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-video-list',
  templateUrl: './video-list.component.html',
  styleUrl: './video-list.component.css'
})
export class VideoListComponent {
  public pageSize = 10;
  public totalItems = 0;
  public pageIndex = 1;
  public orderBy = 'CreatedOn';
  public orderDirection = 'Desc';
  stationControl = new FormControl<StationListModel | string | null>('');
  filteredStation!: Observable<StationListModel[]>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  videoList: VideoListModel[] = [];
  videoModel: VideoModel = new VideoModel();
  dataSource = new MatTableDataSource<VideoListModel>();
  isAdvanceSearchFilter: boolean = false;
  selectedVideoCategory: string | null = null;
  selectedType: string | null = null;
  selectedIsActive: boolean | null = null;
  selectedCode: string | null = null;
  videoCategoryEnum = Object.values(VideoCategoryEnum);
  videoCategorys = VideoCategoryEnum;
  videoTypeEnum = Object.values(VideoTypeEnum);
  currentSort!: Sort;
  displayedColumns = ['Category','AutoPurge','StationId','Type','Code','IsActive','UpdatedOn', 'Action'];
  isWritePermission: boolean = true;
  stationList: StationListModel[] = [];
  allStationList: StationListModel[] = [];
  loadCount = 0;

  constructor(public _restAPI: RestAPIService, public dialog: MatDialog, private toast: ToastService, private permissionService: PermissionService){
    this._restAPI.loading  = false;
    if(!this.permissionService.has('video.write')){
      this.isWritePermission = false;
      this.displayedColumns = this.displayedColumns.filter(col => col !== 'Action');
    }
  }

  ngOnInit() {
    this.getStationList();
    if (localStorage["applyVideoFilterValue"] === 'true') {
        this.getVideoList(localStorage["videoFilterValue"]);
    }
    else {
        this.getVideoList('');
    }
    localStorage["applyVideoFilterValue"] = '';
  }

  onDisplayFilter(e : any) {
    this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
    if(e) {
        e.stopPropagation();
    }
  }

  onVideoCategoryChange (e: any) {
    this.stationControl.setValue('');
    this.selectedType = null;
    this.selectedCode = null;
  }

  openVideoDialog(videoModel: VideoModel): void {
    const dialogRef = this.dialog.open(VideoAddEditComponent, {
        width:"1024px",
        data:{
            videoModel: videoModel,
            stationList: this.stationList
        } 
    });

    dialogRef.afterClosed().subscribe(result => {
        this.videoModel = new VideoModel();
        if (result) {
            this.getVideoList(localStorage["videoFilterValue"]);
        }
        localStorage["applyVideoFilterValue"] = '';
    });
  }

  async getVideoList(filterValue : any) {
    this._restAPI.loading  = true;
    let postData = {
      page: this.pageIndex,
      pageSize: this.pageSize,
      orderBy: this.orderBy,
      direction: this.orderDirection,
      model: {
        category: this.selectedVideoCategory,
        stationId: this.selectedVideoCategory === this.videoCategorys.StationSpecific ? this.getStationId() : null,
        type: this.selectedVideoCategory === this.videoCategorys.StationSpecific ? this.selectedType : null,
        code: (this.selectedVideoCategory === this.videoCategorys.Cancel || this.selectedVideoCategory === this.videoCategorys.Delay) ? this.selectedCode : null,
        isActive: this.selectedIsActive
      }
    }
    this._restAPI.post<PaginatedResult<VideoListModel>>(environment.apiURL + 'api/video/list', postData).subscribe({
        next: (data) => {
          this.loadCount = this.loadCount + 1;
          if(this.loadCount > 1){
            this._restAPI.loading  = false;
          }
          for(let videoObj of data.items){
              if(!videoObj.updatedOn){
                  videoObj.updatedOn = videoObj.createdOn;
              }
          }
          this.videoList = data.items;
          this.totalItems = Number(data.totalItems);
          console.log(this.totalItems);
          this.dataSource.data = data.items;
          this.dataSource.filter = filterValue;
          this.dataSource.sort = this.sort;
          //this.dataSource.paginator = this.paginator;
        },
        error: (error) =>{console.error(error); this.loadCount + 1; if(this.loadCount > 1){ this._restAPI.loading  = false; }}
    });
  }

  async getStationList() {
    this._restAPI.loading  = true;
    this._restAPI.get<StationListModel[]>(environment.apiURL + 'api/station/list').subscribe({
        next: (data) => {
          this.loadCount = this.loadCount + 1;
          if(this.loadCount > 1){
            this._restAPI.loading  = false;
          }
          this.allStationList = data;
          for(let stationObj of data){
              if(stationObj.isActive){
                this.stationList.push(stationObj);
              }
          }
          this.stationList = this.stationList.sort((a, b) => a.name!.localeCompare(b.name!));
          this.filteredStation = this.stationControl.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : 'value?.name'),
            map(name => name ? this._filterStation(name) : this.stationList.slice())
          );
        },
        error: (error) =>{console.error(error);this.loadCount + 1; if(this.loadCount > 1){ this._restAPI.loading  = false; }}
    });
  }

  displayStation(station: StationListModel): string {
    return station && station.name ? station.crsCode + ' - ' + station.name : '';
  }

  private _filterStation(name: string): StationListModel[] {
    if (name) {
      name = name.includes(' - ') ? name.slice(name.indexOf(' - ')) : name;
      name = name.replace(' - ','');
    }
    const filterValue = name.toLowerCase();
    return this.stationList.filter(station => station.name!.toLowerCase().includes(filterValue) || station.crsCode!.toLowerCase().includes(filterValue));
  }

  clearFilter(){
    this.selectedVideoCategory = null;
    this.stationControl.setValue('');
    this.selectedType = null;
    this.selectedIsActive = null;
    this.selectedCode = null;
    localStorage["videoFilterValue"] = '';
    this.dataSource.filter = '';
    this.pageIndex = 1;
    this.getVideoList(localStorage["videoFilterValue"]);
  }

  applyFilter(){
    this.pageIndex = 1;
    this.getVideoList(localStorage["videoFilterValue"]);
  }

  onPageChange(event: PageEvent){
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getVideoList(localStorage["videoFilterValue"]);
  }

  sortVideos(sort: Sort) {
    if (this.dataSource?.paginator) {
        this.dataSource.paginator.pageIndex = 0;
    }
    this.currentSort = sort;
    this.pageIndex = 0;
    this.orderBy = sort.active;
    this.orderDirection = sort.direction;
    this.pageIndex = 1;
    this.getVideoList(localStorage["videoFilterValue"]);
  }

  onToggleChange(event: MatSlideToggleChange, id: string){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '500px',
        data: {
          message: `Are you sure you want to ${event.checked ? 'active' : 'inactive'} this Video?`
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
            console.log('Toggle changed:', event.checked); // true or false

            let postData = {
                videoId: id,
                isActive: event.checked
              };

            this._restAPI.loading  = true;  
            this._restAPI.put<string>(environment.apiURL + 'api/video/activeinactive', postData).subscribe({
                next: (results) => {
                    this._restAPI.loading  = false;
                    dialogRef.close(true);
                    this.toast.show("Video has been updated succussfully");
                },
                error: (error) => {console.error(error);this._restAPI.loading  = false;}
            });
        }
        else{
            event.source.checked = !event.checked;
        }
      });
  }

  private getDate(date : Date | null){
      if(date){
          return moment.utc(date).local().format('YYYY-MM-DD hh:mm A');
      }
      else{
          return null;
      }
  }

  private getStationName(stationId: string | null){
    if(stationId) {
      var data = this.allStationList.filter(option => option.id === stationId);
      if(data && data.length > 0)
        return data[0].crsCode + ' - ' + data[0].name;
      else
        return '';
    }
    else {
      return '';
    }
  }

  private getStationId () {
    if (typeof this.stationControl.value === 'object' && this.stationControl.value){
      return this.stationControl.value.id;
    }
    else {
      return null;
    }
  }
}
